import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'
import { useCurrentUser } from '@/features/auth/hooks/use-current-user'

interface UpdateUserTeamsData {
  userId: string
  teamIds: string[]
}

async function updateUserTeams(data: UpdateUserTeamsData): Promise<void> {
  const { error } = await supabase.rpc('update_user_teams', {
    p_user_id: data.userId,
    p_team_ids: data.teamIds,
  })

  if (error) {
    if (error.message.includes('Only admins')) {
      throw new Error('NOT_ADMIN')
    }
    throw new Error(error.message)
  }
}

export function useUpdateUserTeams() {
  const queryClient = useQueryClient()
  const { user } = useCurrentUser()

  return useMutation({
    mutationFn: updateUserTeams,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationUsers', user?.organization_id] })
    },
  })
}
